import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$2 } from './avatar.js';
import { d as defineCustomElement$1 } from './icon.js';

const traySpeakerHolderCss = ".speaker-info{display:flex;align-items:center;font:var(--tt-font-standard);column-gap:0.5rem}.speaker-info .speaker-details{display:flex;flex-direction:column;overflow:hidden}.speaker-info .speaker-details .speaker-title-company{color:var(--tt-color-gray-600);display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}.speaker-info .speaker-details .speaker-name{font:var(--tt-font-medium);white-space:nowrap}.speaker-info .speaker-details .speaker-name,.speaker-info .speaker-details .speaker-title-company{min-width:0;overflow:hidden;text-overflow:ellipsis}";

const TraySpeakerHolder = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.imageUrl = undefined;
    this.name = undefined;
    this.jobTitle = undefined;
    this.company = undefined;
  }
  render() {
    return (h(Host, null, h("div", { class: "speaker-info" }, h("tt-avatar", { class: "speaker-avatar", image: this.imageUrl }), h("div", { class: "speaker-details" }, h("span", { class: "speaker-name" }, this.name), h("span", { class: "speaker-title-company" }, this.jobTitle, " ", this.jobTitle && this.company && `\u{00B7}`, " ", this.company)))));
  }
  static get style() { return traySpeakerHolderCss; }
}, [1, "tt-tray-speaker-holder", {
    "imageUrl": [1, "image-url"],
    "name": [1],
    "jobTitle": [1, "job-title"],
    "company": [1]
  }]);
function defineCustomElement() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["tt-tray-speaker-holder", "tt-avatar", "tt-icon"];
  components.forEach(tagName => { switch (tagName) {
    case "tt-tray-speaker-holder":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, TraySpeakerHolder);
      }
      break;
    case "tt-avatar":
      if (!customElements.get(tagName)) {
        defineCustomElement$2();
      }
      break;
    case "tt-icon":
      if (!customElements.get(tagName)) {
        defineCustomElement$1();
      }
      break;
  } });
}

export { TraySpeakerHolder as T, defineCustomElement as d };
